import { Legend } from "../types";
import { COMMUNITY_COLORS } from "./community-classes.constant";

export const MOD_COMMUNITY_LEGENDS: Legend[] = [
  {
    color: '#ff92b5ff',
    name: 'Kit em Produção'
  },
  {
    color: '#F1F1F1',
    name: 'Envio Destinado'
  },
  {
    color: '#0072F1',
    name: 'Em Trânsito'
  },
  {
    color: '#495E68',
    name: 'Aguardando Ativação'
  },
  {
    color: '#fff25dff',
    name: 'Aguardando Instalação'
  },
  {
    color: '#61D96F',
    name: 'Instalado'
  },
]

export const CONNECTION_TYPE_LEGENDS: Legend[] = [
  {
    color: '#61D96F',
    name: 'Conexão Fixa'
  },
  {
    color: '#00B6F0',
    name: 'Conexão Móvel'
  },
  {
    color: '#D732C6',
    name: 'Antenas Externas Incorporadas'
  },
]

export const CONTRACT_TYPE_LEGENDS: Legend[] = [
  {
    color: '#61D96F',
    name: 'Rede Povos'
  },
  {
    color: '#00B6F0',
    name: 'Antenas Externas Incorporadas'
  },
]

export const ENERGY_KIT_LEGENDS: Legend[] = [
  {
    color: '#61D96F',
    name: 'Kit BackUp'
  },
  {
    color: '#00B6F0',
    name: 'Kit OffGrid'
  },
  {
    color: '#FFDB2B',
    name: 'Sem Kit de Energia'
  }
]

export const ASSOCIATIVE_DOCUMENT_LEGENDS: Legend[] = [
  {
    color: '#61D96F',
    name: 'Associado'
  },
  {
    color: '#00B6F0',
    name: 'Não Associado'
  },
]

export const ROUTER_MODEL_LEGENDS: Legend[] = [
  {
    color: '#61D96F',
    name: 'U6 - Versão 1'
  },
  {
    color: '#00B6F0',
    name: 'UX - Versão 3'
  }
]

export const SELECTABLE_LEGENDS: any[] = [
  {
    name: 'Status do Kit',
    legends: MOD_COMMUNITY_LEGENDS,
    isSelected: true
  },
  {
    name: 'Tipo de conexão',
    legends: CONNECTION_TYPE_LEGENDS,
    isSelected: false
  },
  {
    name: 'Tipo de contrato',
    legends: CONTRACT_TYPE_LEGENDS,
    isSelected: false
  },
  {
    name: 'Modelo do Kit de energia',
    legends: ENERGY_KIT_LEGENDS,
    isSelected: false
  },
  {
    name: 'Associação',
    legends: ASSOCIATIVE_DOCUMENT_LEGENDS,
    isSelected: false
  },
  {
    name: 'Modelo do roteador',
    legends: ROUTER_MODEL_LEGENDS,
    isSelected: false
  }
]
